import Axios from "axios";
import {
    SET_BRANCH_MODULE_LIST,
    UNSET_BRANCH_MODULE_LIST,
    SET_TEMP_BRANCH_MODULE_LIST,
    UNSET_TEMP_BRANCH_MODULE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateBranchModule, getBranchModuleList } from "@/store/api";
// initial state
const state = {
  getBranchModuleList: [],
  getTempBranchModuleList: [],
};

const getters = {
  getBranchModuleList(state) {
    return state.getBranchModuleList;
  },
  getTempBranchModuleList(state) {
    return state.getTempBranchModuleList;
  }
};
const mutations = {
  [SET_BRANCH_MODULE_LIST](state, data) {
    state.getBranchModuleList = data;
  },
  [UNSET_BRANCH_MODULE_LIST](state) {
    state.getBranchModuleList = [];
  },
  [SET_TEMP_BRANCH_MODULE_LIST](state, data) {
    state.getTempBranchModuleList = data;
  },
  [UNSET_TEMP_BRANCH_MODULE_LIST](state) {
    state.getTempBranchModuleList = [];
  }
};

const actions = {

  saveUpdateBranchModule({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateBranchModule, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getBranchModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getBranchModuleList, data)
        .then(function (response) {
          commit('SET_BRANCH_MODULE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BRANCH_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
